import axios from 'axios'

let sessionRequest = axios.create({
    baseURL: '/routenplaner/login/sessions'
});

if(process.env.NODE_ENV === 'development') {
    sessionRequest = axios.create({
        baseURL: 'https://loginint.oeamtc.at/legacy/api/identity/v1/sessions/'
    });
}

let authApi = axios.create({
    baseURL: '/routenplaner/auth',
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
});

export default {
    getUser(sessionToken) {
        return sessionRequest.get(`/${sessionToken}`)
    },
    ntlmLogin(scope) {
        return axios.create({
            baseURL: process.env.BASE_URL,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).get( '/auth-ntlm/token', {
            'params': {
                'scope': scope
            }
        })
    },
    loginWithPassword(username, password, scope) {
        const params = new URLSearchParams();
        params.append('grant_type', 'password');
        params.append('username', username);
        params.append('password', password);
        params.append('scope', scope);
        // return authApi.post('/token', params)
        return axios.create({
            baseURL: process.env.BASE_URL,
        }).post( '/auth-internal/token', params)
    },
    getUserSessionData(ssoId) {
        const params = new URLSearchParams();
        params.append('grant_type', 'ssoid');
        params.append('ssoid', ssoId);
        params.append('scope', 'openid');
        return authApi.post('/token', params)
    },
    refreshUserSessionData(refreshToken) {
        const params = new URLSearchParams()
        params.append('grant_type', 'refresh_token')
        params.append('refresh_token', refreshToken)
        return authApi.post('/token', params)
    },
}